import { ACTOR_ID_HEADER_KEY, PAYMENT_SERVICE_BASE_URL } from "constants";
import apiClient from "utils/apiClient";

const BASE = `${PAYMENT_SERVICE_BASE_URL}/api/v1/payments/payout`;
const SKIP_WORKSPACE_CONTEXT_HEADER = "O-SKIP-WORKSPACE-CONTEXT";
const WORKSPACE_ID_HEADER = "O-WORKSPACE-ID";

const actorHeaders = ({ actorId, workspaceId } = {}) => ({
  ...(actorId ? { [ACTOR_ID_HEADER_KEY]: actorId } : {}),
  ...(workspaceId
    ? {
        [SKIP_WORKSPACE_CONTEXT_HEADER]: "true",
        [WORKSPACE_ID_HEADER]: workspaceId,
      }
    : {}),
});

export const paymentTransfersService = {
  received: {
    listForUser: async ({ actorId, userId, workspaceId, page = 0, size = 20 } = {}) => {
      const response = await apiClient.get(`${BASE}/user/${encodeURIComponent(userId || actorId)}/received`, {
        params: {
          payeeWorkspaceId: workspaceId || undefined,
          wid: workspaceId || undefined,
          page,
          size,
        },
        headers: actorHeaders({ actorId, workspaceId }),
      });
      return response.data || { content: [] };
    },
  },
};

export default paymentTransfersService;
